export default __webpack_public_path__ + "static/media/1.a55eae3d.jpg";